export default __webpack_public_path__ + "static/media/fortunext1.41036cbe.JPG";